import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

function Form007SubmittedDialog({ formOpen, onConfirm, onClose }) {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Dialog aria-labelledby="simple-dialog-title" open={formOpen}>
                <DialogTitle id="simple-dialog-title">
                    {t("common.switchLang.title")}
                </DialogTitle>
                <DialogContent>{t("Form007.dialog.message")}</DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.confirm")}</b>
                    </Button>
                    <Button autoFocus onClick={onClose} color="success">
                        <b>{t("common.portal.close")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form007SubmittedDialog;
